export enum EParcelPlacesFormControlNames {
  codeUKTZED = 'codeUKTZED',
  codeUKTZEDDest = 'codeUKTZEDDest',
  description = 'description',
  brandModel = 'brandModel',
  cost = 'cost',
  weight = 'weight',
  weightUnit = 'weightUnit',
  amount = 'amount',
  units = 'units',
  materials = 'materials',
  country = 'country',
  currency = 'currency',
}
